export { type PageProps, default as Page } from './Page';
